import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
} from "@angular/core";

@Component({
  selector: "app-consulta-historico-rf-pro",
  templateUrl: "./consulta-historico-rf-pro.component.html",
  styleUrls: ["./consulta-historico-rf-pro.component.scss"],
})
export class ConsultaHistoricoRFProComponent implements OnInit, OnChanges {
  @Input() consulta: any;
  @Input() titulo = "";
  @Input() idConsulta = "";
  @Input() tipoConsulta = "";
  @Input() codigoControle = "";
  @Input() token = "";

  @Output() update = new EventEmitter();

  statusMsg = null;
  status = "info";
  texto: any;
  ufMun: string[] = [];
  uf: string = "";
  municipio: string = "";
  dataUltimaAtualizacao: Date = null;
  semOcorrencia: boolean = false;

  constructor() {}

  ngOnInit() {
    this.setStatus();
  }

  ngOnChanges() {
    this.setStatus();
  }

  setStatus() {
    this.semOcorrencia = false;

    if (this.consulta?.ufJurisdicao) {
      this.ufMun = this.consulta?.ufJurisdicao?.split("/");
      this.uf = this.ufMun[1];
      this.municipio = this.ufMun[0];
    }
    if (this.consulta?.dataUltimaAtualizacao) {
      this.dataUltimaAtualizacao = new Date(
        this.consulta?.dataUltimaAtualizacao
      );
    }

    if (
      this.consulta?.ocorrenciaHistoricoRFPro == null ||
      this.consulta?.ocorrenciaHistoricoRFPro?.length == 0
    ) {
      this.semOcorrencia = true;
      this.statusMsg = "OCORRÊNCIA";
      this.texto =
        "NÃO FORAM ENCONTRADAS OCORRÊNCIAS PARA ESTE VEÍCULO.";
    }
  }
}
